module.exports = __webpack_public_path__ + "static/img/6.9b76cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/6.png
// module id = mpy8
// module chunks = 0